<template>
  <div>
    <!-- dialog displaying data about the locus (fucntional annotation, file links (vcf, etc)  -->
    <locus-description-dialog
      v-if="displayAnnotDialog"
      :locus="geneId"
      :annotations="locusAnnotations"
      @close="displayAnnotDialog = false"
    ></locus-description-dialog>
    <v-container class="ma-0 pa-0">
      <!-- <v-row no-gutters class="ma-0 pa-0"> -->
      <!-- <v-col cols="4"> -->
      <v-btn class="ml-4" elevation="1" rounded color="black" dark text @click="showAnnotDialog">
        {{ geneId }}
      </v-btn>
      <!-- </v-col> -->
      <!-- <v-col cols="8">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="subheading" v-on="on">{{ shortSelectedGenotypes }}</span>
            </template>
            <span class="mr-4">{{ formattedSelectedGenotypes }}</span>
          </v-tooltip>
        </v-col> -->
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
import LocusDescriptionDialog from '@/components/locus/LocusDescriptionDialog.vue';
export default {
  components: {
    LocusDescriptionDialog,
  },
  props: {
    geneId: {
      type: String,
      default: '',
    },
    annotations: {
      type: Array,
      default: function() {
        return [];
      },
    },
    selectedGenotypes: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      displayAnnotDialog: false,
      maxAnnotLength: 100,
    };
  },
  computed: {
    locusAnnotations() {
      if (this.annotations.length > 0) {
        var displayAnnotationData = this.annotations.map(a => {
          var b = {
            locus_tag: a.locus_tag,
            product: a.product.replace(/%2C/, ','),
            ec_number: a.ec_number,
            Ontology_term: a.Ontology_term,
            type: a.type,
          };
          return b;
        });
        return displayAnnotationData;
      }
      return '';
    },
    summaryLocusAnnotation() {
      const defAnnotation = 'More...';
      if (this.annotations.length > 0) {
        var products = '';
        if (this.annotations[0].product) products = this.annotations[0].product;
        if (products.length > this.maxAnnotLength) {
          var p = products.substr(0, this.maxAnnotLength);
          products = p + '...';
        }
        if (products !== '') return products.replace(/%2C/g, ',');
        else {
          return defAnnotation;
        }
      }
      return defAnnotation;
    },
    formattedSelectedGenotypes() {
      if (this.selectedGenotypes.length > 0) {
        return this.selectedGenotypes.map(g => g.name).join(', ');
      } else {
        return '';
      }
    },
    shortSelectedGenotypes() {
      if (this.selectedGenotypes.length > 0) {
        const l = this.selectedGenotypes.map(g => g.name).join(', ');
        if (l.length > 100) {
          return l.substr(0, 100) + '...';
        } else return l;
      } else {
        return '';
      }
    },
  },
  methods: {
    showAnnotDialog() {
      this.displayAnnotDialog = true;
    },
  },
};
</script>
<style scoped>
.annot {
  text-transform: none !important;
}
</style>
